import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import { Col, Container, Row } from 'react-bootstrap';
import { AvatarParams, AvatarSize, AvatarStatus } from '../Avatar/Avatar';
import ExpandableCard from './ExpandableCard';

export const avatars: AvatarParams[] = [
  {
    id: '1',
    image: 'conduent_profile.jpeg',
    status: AvatarStatus.ENABLED,
    size: AvatarSize.EXTRA_SMALL,
    name: 'Test Name',
    hasTooltip: false,
  },
  {
    id: '2',
    image: 'conduent_profile.jpeg',
    status: AvatarStatus.ENABLED,
    size: AvatarSize.EXTRA_SMALL,
    name: 'Test Name',
    hasTooltip: false,
  },
  {
    id: '3',
    image: 'conduent_profile.jpeg',
    status: AvatarStatus.ENABLED,
    size: AvatarSize.EXTRA_SMALL,
    name: 'Test Name',
    hasTooltip: false,
  },
  {
    id: '4',
    image: '',
    status: AvatarStatus.ENABLED,
    size: AvatarSize.EXTRA_SMALL,
    name: 'Test Name',
    hasTooltip: false,
  },
  {
    id: '5',
    image: 'conduent_profile.jpeg',
    status: AvatarStatus.ENABLED,
    size: AvatarSize.EXTRA_SMALL,
    name: 'Test Name',
    hasTooltip: false,
  },
  {
    id: '6',
    image: 'conduent_profile.jpeg',
    status: AvatarStatus.ENABLED,
    size: AvatarSize.EXTRA_SMALL,
    name: 'Test Name',
    hasTooltip: false,
  },
  {
    id: '7',
    image: 'conduent_profile.jpeg',
    status: AvatarStatus.ENABLED,
    size: AvatarSize.EXTRA_SMALL,
    name: 'Test Name',
    hasTooltip: false,
  },
  {
    id: '8',
    image: 'conduent_profile.jpeg',
    status: AvatarStatus.ENABLED,
    size: AvatarSize.EXTRA_SMALL,
    name: 'Test Name',
    hasTooltip: false,
  },
  {
    id: '9',
    image: 'conduent_profile.jpeg',
    status: AvatarStatus.ENABLED,
    size: AvatarSize.EXTRA_SMALL,
    name: 'Ivanov',
    hasTooltip: false,
  },
  {
    id: '10',
    image: 'conduent_profile.jpeg',
    status: AvatarStatus.ENABLED,
    size: AvatarSize.EXTRA_SMALL,
    name: 'Test Name',
    hasTooltip: false,
  },
  {
    id: '11',
    image: 'conduent_profile.jpeg',
    status: AvatarStatus.ENABLED,
    size: AvatarSize.EXTRA_SMALL,
    name: 'Daniel Ivanov',
    hasTooltip: false,
  },
];

const ExpandableCardDemo = () => {
  return (
    <Container>
      <Container className="mt-10">
        <h4>Expandable Card</h4>
        <Row>
          <Col className="mt-10">
            <ExpandableCard
              title="Medical"
              subtitle="Cigna Consumer Choice HDHP"
              avatars={avatars}
              cardIcon={light('heart-pulse')}
              iconOnClick={(name) => console.log(name)}
            />
          </Col>
          <Col className="mt-10">
            <ExpandableCard
              title="Dental"
              subtitle="DMO Plan"
              avatars={avatars}
              cardIcon={light('tooth')}
              iconOnClick={(name) => console.log(name)}
            />
          </Col>
          <Col className="mt-10">
            <ExpandableCard
              title="Vision"
              subtitle="Standard Plan"
              avatars={avatars}
              cardIcon={light('glasses')}
              iconOnClick={(name) => console.log(name)}
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
};

export default ExpandableCardDemo;
